import { type WorkspaceRepository } from '@telespot/domain';
import { type CommandHandler } from '@telespot/core';

import { DeleteWorkspace } from './delete-workspace.command';

/**
 * @group Workspaces
 * @category Handlers
 */
export type IDeleteWorkspaceHandler = CommandHandler<DeleteWorkspace>;

/**
 * @group Workspaces
 * @category Handlers
 */
export class DeleteWorkspaceHandler implements IDeleteWorkspaceHandler {
  constructor(private readonly workspaces: WorkspaceRepository) {}

  public async execute(command: DeleteWorkspace): Promise<boolean> {
    return this.workspaces.delete(command.details.workspaceId);
  }
}
